import {
  IndexFilters,
  // useSetIndexFiltersMode,
  ChoiceList,
  Tooltip,

} from '@shopify/polaris';
import { useEffect } from 'react';

import { useState, useCallback } from 'react';
import Langauge from '../../i18n/Language';
const t = Langauge;

const TableFilters = (props) => {
  // const [isSetText, setIsSetText] = useState(0);
  const {
    loading,
    queryValue,
    setSelectedTabsIndex,
    setQueryValue,
    itemStrings,
    typeSelected,
    isShowFilters,
    setIssueTypeChange,
    issueListData,
    isDisabledQuery,
    isDiyTitle,
    scoreListData,
    isOnpage,
    seoScoreSel,
    custom,
    searchTip,
    pageFilter,
    categoryList,
    pageStatusList,
    focusKeywordListData,
    searchMode,
    resetParams,
    competitorList,
    originWebsite,
    tabMode,

    handleSetMode,
    setSeoScoreChange,
    setCategoryTypeChange,
    setPageStatusChange,
    setFocusKeywordChange,
    handleCompetitorChange,

  } = props;

  // 分类排序
  const [sortSelected, setSortSelected] = useState(['order desc']);
  const [selected, setSelected] = useState(0);
  const [seoScore, setSeoScore] = useState([]); // 分数 过滤条件
  const [focusKeyword, setFocusKeyword] = useState([]); // 关键词 过滤条件
  const [mode, setMode] = useState('DEFAULT'); // DEFAULT || FILTERING 


  // 标题
  const tabs = itemStrings.map((item, index) => ({
    content: Boolean(custom) && mode === 'DEFAULT' ? <Tooltip content={t(item.desc)}>
      <label>{t(item.title)}</label>
    </Tooltip> : (Boolean(custom) ? t(item.title) : t(item)),
    index,
    onAction: () => { },
    id: `${item}-${index}`,
    isLocked: 1,
    actions: [],
  }));
  const onCreateNewView = async (value) => {
    return value;
  };

  // 分类 排序
  const handleSortSelected = (e) => {
    setSortSelected(e)
  }

  // 选择对应条件过滤
  const [issueType, setIssueType] = useState([]);
  const handleIssueTypeChange = useCallback(
    (value) => {
      setIssueType(value)
      setIssueTypeChange(value)
    },
    [],
  );

  // 选择对应条件过滤
  const [categoryType, setCategoryType] = useState([]); // 筛选分类
  const handleCategoryTypeChange = useCallback(
    (value) => {
      setCategoryType(value)
      setCategoryTypeChange(value)
    },
    [],
  );
  const handleCategoryRemove = (state = 0) => {
    setCategoryType([]);
    if (state === 1) {
      setCategoryTypeChange([], -1);
    } else {
      setCategoryTypeChange([]);
    }
  };

  // 页面类型 关键词
  const [pageStatusType, setPageStatusType] = useState([]); // 筛选分类
  const handlePageStatusChange = useCallback(
    (value) => {
      setPageStatusType(value)
      setPageStatusChange(value)
    },
    [],
  );
  const handlePageStatusRemove = (state = 0) => {
    setPageStatusType([]);
    if (state === 1) {
      setPageStatusChange(-1);
    } else {
      setPageStatusChange([]);
    }
  };


  // 输入搜索内容
  const handleQueryValueChange = useCallback(
    (value) => {
      setQueryValue(value); // 传递父亲 设置value
    },
    [],
  );

  // 清空
  const clearQueryValueChange = () => {
    setQueryValue(''); // 传递父亲 设置value
  }

  // 单独删除对应过滤条件
  const handleIssueTypeRemove = useCallback(() => {
    setIssueType([])
    if (setIssueTypeChange) {
      setIssueTypeChange(-1)
    }
  }, []);

  // 选中分数条件
  const handleSEOScoreChange = (val) => {
    setSeoScore(val);
    setSeoScoreChange(val);
  };
  const handleSEOScoreRemove = () => {
    setSeoScore([]);
    setSeoScoreChange(-1);
  };

  // 选择关键词条件
  const handleFocusKeywordChange = (val) => {
    setFocusKeyword(val);
    setFocusKeywordChange(val);
  };
  const handleFocusKeywordRemove = () => {
    setFocusKeyword([]);
    setFocusKeywordChange(-1);
  };


  // 删除搜索内容
  const handleQueryValueRemove = useCallback(() => setQueryValue(''), []);

  // 清除过滤条件
  const handleFiltersClearAll = useCallback(() => {
    handleQueryValueRemove();
    handleIssueTypeRemove();
    if (isOnpage) {
      // onpage 独有
      handleSEOScoreRemove();
      handleFocusKeywordRemove();
    }

    if (['keywordGap', 'MyWebKeywords'].indexOf(pageFilter) > -1) {
      // 关键词对比
      handleCategoryRemove(1);
      if (['keywordGap'].indexOf(pageFilter) > -1) {
        handleCompetitorChange([]);
      }
    }

    // 关键词 页面状态
    if (['MyWebKeywords'].indexOf(pageFilter) > -1) {
      handlePageStatusRemove(1);
    }
  }, [
    handleQueryValueRemove,
    handleIssueTypeRemove,
    handleSEOScoreRemove,
    handleCategoryRemove,
    handlePageStatusRemove,
    handleFocusKeywordRemove,
  ]);

  const filters = isOnpage ? [
    {
      key: 'issueType',
      label: Boolean(isDiyTitle) ? t(isDiyTitle) : t("Issue Category"),
      filter: (
        <ChoiceList
          title={Boolean(isDiyTitle) ? t(isDiyTitle) : t("Issue Category")}
          titleHidden
          choices={issueListData}
          selected={issueType || []}
          onChange={handleIssueTypeChange}
        />
      ),
      shortcut: true,
    },
    {
      key: 'seoScore',
      label: t("SEO Score"),
      filter: (
        <ChoiceList
          title={t("SEO Score")}
          titleHidden
          choices={scoreListData}
          selected={seoScore || []}
          onChange={handleSEOScoreChange}
        />
      ),
      shortcut: true,
    },
    {
      key: 'focusKeyword',
      label: t("Focus keyword"),
      filter: (
        <ChoiceList
          title={t("Focus keyword")}
          titleHidden
          choices={focusKeywordListData}
          selected={focusKeyword || []}
          onChange={handleFocusKeywordChange}
        />
      ),
      shortcut: true,
    }
  ] : pageFilter === 'keywordGap' ? [
    {
      key: 'Competitors',
      label: t("Competitors"),
      filter: (
        <ChoiceList
          title={t("Competitors")}
          titleHidden
          choices={competitorList}
          selected={originWebsite || []}
          onChange={handleCompetitorChange}
          allowMultiple
        />
      ),
      shortcut: true,
      pinned: true,
    },
    {
      key: 'categoryType',
      label: t("Category"),
      filter: (
        <ChoiceList
          title={t("Category")}
          titleHidden
          choices={categoryList}
          selected={categoryType || []}
          onChange={handleCategoryTypeChange}
        />
      ),
      shortcut: true,
    }
  ] : pageFilter === 'MyWebKeywords' ? [
    {
      key: 'categoryType',
      label: t("Page Type"),
      filter: (
        <ChoiceList
          title={t("Page Type")}
          titleHidden
          choices={categoryList}
          selected={categoryType || []}
          onChange={handleCategoryTypeChange}
        />
      ),
      shortcut: true,
    },
    {
      key: 'pageStatusType',
      label: t("Page Status"),
      filter: (
        <ChoiceList
          title={t("Page Status")}
          titleHidden
          choices={pageStatusList}
          selected={pageStatusType || []}
          onChange={handlePageStatusChange}
        />
      ),
      shortcut: true,
    }
  ] : [
    {
      key: 'issueType',
      label: Boolean(isDiyTitle) ? t(isDiyTitle) : t("Issue Category"),
      filter: (
        <ChoiceList
          title={Boolean(isDiyTitle) ? t(isDiyTitle) : t("Issue Category")}
          titleHidden
          choices={issueListData}
          selected={issueType || []}
          onChange={handleIssueTypeChange}
        />
      ),
      shortcut: true,
    }
  ];
  const appliedFilters = [];
  if (issueType && !isEmpty(issueType)) {
    const key = 'issueType';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, issueType),
      onRemove: handleIssueTypeRemove,
    });
  }
  if (seoScore && !isEmpty(seoScore)) {
    const key = 'seoScore';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, seoScore),
      onRemove: handleSEOScoreRemove,
    });
  }
  if (focusKeyword && !isEmpty(focusKeyword)) {
    const key = 'focusKeyword';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, focusKeyword),
      onRemove: handleFocusKeywordRemove,
    });
  }
  if (originWebsite && !isEmpty(originWebsite)) {
    const key = 'Competitors';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, originWebsite),
      onRemove: () => handleCompetitorChange([]),
    });
  }
  if (categoryType && !isEmpty(categoryType)) {
    const key = 'categoryType';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, categoryType),
      onRemove: handleCategoryRemove,
    });
  }
  if (pageStatusType && !isEmpty(pageStatusType)) {
    const key = 'pageStatusType';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, pageStatusType),
      onRemove: handlePageStatusRemove,
    });
  }

  // 选择tab
  const setSelectedTabs = (e) => {
    setSelected(e);
    setSelectedTabsIndex(e);
  }

  const onHandleCancel = () => {
    if (queryValue !== '' || issueType.length > 0 || seoScore.length > 0 || categoryType.length > 0 || focusKeyword.length > 0) {
      handleFiltersClearAll();
    }
  }; // 取消

  useEffect(() => {
    if (window.location.pathname === '/on-page-seo') {
      handleIssueTypeRemove();
    }
    if (typeSelected !== undefined) {
      setSelected(typeSelected); // 设置tab
    }
  }, [typeSelected])

  useEffect(() => {
    if (!Boolean(seoScoreSel) || seoScoreSel === -1) {
      setSeoScore([]);
    } else {
      let val = seoScoreSel === 'Well Done' ? 0 : seoScoreSel === 'Need Improve' ? 1 : seoScoreSel === 'Important Issued' ? 2 : -1;
      if (val !== -1) {
        setMode('FILTERING'); // 设置模式
        setSeoScore([val]);
      } else {
        setMode('DEFAULT'); // 设置模式
        setSeoScore([]);
      }
    }
  }, [seoScoreSel])

  useEffect(() => {
    if (mode === 'DEFAULT' && (queryValue !== '' || issueType.length > 0 || seoScore.length > 0 || pageStatusType.length > 0)) {
      handleFiltersClearAll();
    }

    if (handleSetMode) {
      handleSetMode(mode);
    }
  }, [mode])

  useEffect(() => {
    setMode(searchMode ? 'FILTERING' : 'DEFAULT'); // 设置模式
  }, [searchMode])


  useEffect(() => {
    if (tabMode) {
      setMode(tabMode); // 设置模式
    }
  }, [tabMode])

  useEffect(() => {
    if (resetParams?.page) {
      const _r = resetParams;
      // 问题分类
      let _issueCate = Number(_r.selectIssue) >= 0 ? _r.selectIssue : _r.selectedActive === 'Active' ? 99 : -1;
      if (_issueCate !== -1) {
        handleIssueTypeChange([_issueCate]);
      } else {
        handleIssueTypeRemove();
      }
      // seo分数程度
      let _seoScore = _r.selectedOptimize === 'Well Done' ? 0 : _r.selectedOptimize === 'Need Improve' ? 1 : _r.selectedOptimize === 'Important Issued' ? 2 : -1;
      if (_seoScore !== -1) {
        handleSEOScoreChange([_seoScore]);
      } else {
        handleSEOScoreRemove();
      }
      // 关键词
      let _isKeywords = _r.is_keyword === 1 ? 1 : _r.is_keyword === 0 ? 0 : -1;
      if (_isKeywords !== -1) {
        handleFocusKeywordChange([_isKeywords]);
      } else {
        handleFocusKeywordRemove();
      }

      if (_issueCate !== -1 || _seoScore !== -1 || _isKeywords !== -1) {
        setMode('FILTERING');
      } else {
        setMode('DEFAULT');
      }
    }
  }, [resetParams])

  return (
    <IndexFilters
      sortOptions={false}
      sortSelected={sortSelected}
      queryValue={queryValue}
      queryPlaceholder={searchTip || t("Search in all")}
      onQueryChange={handleQueryValueChange}
      onQueryClear={clearQueryValueChange}
      onSort={handleSortSelected}
      primaryAction={false}
      cancelAction={{
        onAction: onHandleCancel,
        disabled: false,
        loading: false,
      }}
      tabs={tabs}
      selected={selected}
      onSelect={setSelectedTabs}
      canCreateNewView={false}
      onCreateNewView={onCreateNewView}
      filters={filters}
      appliedFilters={appliedFilters}
      onClearAll={handleFiltersClearAll}
      mode={mode}
      setMode={setMode}
      loading={loading}
      hideFilters={!isShowFilters || Boolean(isDisabledQuery)}
      filteringAccessibilityTooltip={`${Boolean(isDisabledQuery) ? `${t("Search (F)")}` : (isShowFilters ? `${t("Search and filter (F)")}` : `${t("Search (F)")}`)}`}
      disableQueryField={Boolean(isDisabledQuery)}
      isFlushWhenSticky={true}
      disableStickyMode={true}
      disableKeyboardShortcuts={true}
      autoFocusSearchField={false}
    />
  );

  function disambiguateLabel(key, value) {
    switch (key) {
      case 'issueType':
        let tag = issueListData.filter(i => i.value === value[0]);
        let tagText = tag.length > 0 ? tag[0]['label'] : '';
        return `Tag: ${tagText}`;
      case 'seoScore':
        let stag = scoreListData.filter(i => i.value === value[0]);
        let stagText = stag.length > 0 ? stag[0]['label'] : '';
        return `Tag: ${stagText}`;
      case 'focusKeyword':
        let fkeytag = focusKeywordListData.filter(i => i.value === value[0]);
        let fkeyText = fkeytag.length > 0 ? fkeytag[0]['label'] : '';
        return `Tag: ${fkeyText}`;
      case 'Competitors':
        let competitorTag = competitorList.filter(i => value.includes(i.value));
        let competitorTagText = '';
        competitorTag.forEach((c, i) => {
          competitorTagText += (i === (value.length - 1)) ? `${c.value}` : `${c.value}, `;
        })
        return `${t("Competitors is")} ${competitorTagText}`;
      case 'categoryType':
        let categoryTag = categoryList.filter(i => i.value === value[0]);
        let categoryTagText = categoryTag.length > 0 ? categoryTag[0]['label'] : '';
        return `Tag: ${categoryTagText}`;
      case 'pageStatusType':
        let pageStatueTag = pageStatusList.filter(i => i.value === value[0]);
        let pageStatusTagText = pageStatueTag.length > 0 ? pageStatueTag[0]['label'] : '';
        return `Tag: ${pageStatusTagText}`;
      default:
        return value;
    }
  }

  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === '' || value == null;
    }
  }
}


export default TableFilters;
